import { createSelector } from "reselect"
import { get, map } from "lodash"
import { getPortfolioDetails, getAccount } from "."

const STEPS = [{
  id: "upload",
  label: "Select Files",
  submitButton: {
    isDisabled: ({ files }) => files.length === 0,
    text: "Scan files",
  },
}, {
  id: "upload/preview",
  label: "Scan Preview",
  submitButton: {
    isDisabled: ({ uploadOption, uploadedFiles, overlappingDates, type }) => {
      if (type === "experiment") return false

      if (overlappingDates.length > 0) {
        return !uploadOption || uploadedFiles.length === 0
      } else {
        return uploadedFiles.length === 0
      }
    },
    text: "Begin upload",
  },
}, {
  id: "upload/complete",
  label: "Upload Complete",
}]

export const getActiveStep = state => get(state, "modules.portfolioPositions.activeStep")

export const getSteps = createSelector(
  [getPortfolioDetails, getAccount],
  (portfolio, account) => {
    if (!portfolio) {
      return STEPS
    } else if (portfolio.type === "experiment") {
      return map(STEPS, step => ({ ...step, url: `/${account}/p/${portfolio.parent.id}/experiments/${portfolio.id}/${step.id}` }))
    } else {
      return map(STEPS, step => ({ ...step, url: `/${account}/p/${portfolio.id}/${step.id}` }))
    }
  },
)
